import React from 'react';
import { ClipLoader } from 'react-spinners';

interface LoaderProps {
  loading?: boolean;
  size?: number;
  color?: string;
  className?: string;
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(255,255,255,0.6)',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'opacity 0.3s',
};

const Loader: React.FC<LoaderProps> = ({ loading = true, size = 48, color = '#1976d2', className }) => {
  if (!loading) return null;
  return (
    <div style={overlayStyle} className={className}>
      <ClipLoader color={color} loading={loading} size={size} />
    </div>
  );
};

export default Loader;
